export enum Colors {
    aquassistPrimary = '#013067',
    aquassistPrimaryButton = '#00A9CE',
    aquassistSecondaryButton = aquassistPrimary,
    aquassistRed = '#E84130',
    aquassistNormRed = '#AD1C3F',
    aquassistWhite = '#FFFFFF',
    aquassistBlack = '#212121',
    aquassistGray1 = '#757575',
    aquassistGray2 = '#9E9E9E',
    aquassistGray3 = '#D5D5D5',
    aquassistGray4 = '#B0B0B0',
    aquassistGray5 = '#8F969E',
    aquassistGray6 = '#EEEFF1',
    aquassistGray7 = '#DCDCDC',
    aquassistGreen = '#3EA34B',
    aquassistYellow = '#F2BA38',
    aquassistOrange = '#F29C38',
    aquassistBrown = '#bb410d',
    aquassistWineRed = '#9F2C41',
    aquassistDarkBlue = '#26384B',
    aquassistLightPurple = '#B3AEFF',
    aquassistDarkPurple = '#6C63FF',
    environmentBarDev = '#D32F2F',
    environmentBarDemo = '#388E3C',
    environmentBarQa = '#1976D2',
    calculatedAnalysisType = '#88AFBD',
    waterConsumptionAnalysisType = '#157362',
    productConsumptionAnalysisType = '#609F78',
    flowMeterConsumptionAnalysisType = '#0d6382',
    aqSelectBorder = '#4E4E4E',
    aquassistBlue1 = '#0072ce',
    hoverBackGround = '#eeeeee',
    containerColor = '#557699',
    networkColor = '#6F9DCE',
    componentColor = '#B3D4FC',
    blueNetworkBg = '#00a9ce',
    aquassistLightBlue = '#f0f9ff',
    d3NodeBorder = '#FFD000',
    d3DashedNodeBorder = '#2196f3',
    serieA = aquassistBlue1,
    serieB = aquassistRed,
    serieC = '#CB30E0',
    serieD = '#2ca02c',
    statusInProgress = '#FBE1C3',
    statusCompleted = '#B4E8AE',
    AQLightBlue = '#e3f0fa',

    // Event Management colors
    eventManagementGray = '#e0e0e0',
    eventManagementTableHeaderBg = '#f5f5f5',
    eventManagementAvatarBg = eventManagementGray,
    eventManagementAvatarText = '#424242',
    eventManagementBadgeGreenBg = '#E6F4EA',
    eventManagementBadgeGreenText = '#1E8E3E',
    eventManagementBadgePinkBg = '#fce4ec',
    eventManagementBadgePinkText = '#b71c1c',
    eventManagementBadgeRedBg = '#FDECEA',
    eventManagementBadgeRedText = '#D93025',
    eventManagementBadgeGreyBg = '#F2F2F2',
    eventManagementBadgeGreyText = '#4A4A4A',
    eventManagementPanelBorder = '#d4d4d4',
    eventManagementPanelBg = '#fff',
    eventManagementDivider = eventManagementGray,
    eventManagementToggleBg = '#e8e8e8',
    eventManagementToggleText = '#666',
    eventManagementToggleActiveBg = '#ffffff',
    eventManagementToggleActiveText = '#333',
    eventManagementGroupBg = '#fafafa',
    eventManagementCardBorder = '#f0f0f0',
    eventManagementOverdueBg = '#FEECEC',
    eventManagementDueTodayBg = '#EAF3FF',
    aqPurple = '#6422aa',
}
